import * as sentry from '../../src/utils/sentry'
import type { FlowReportStatus, FlowReportUpdate } from '../../../app-core/lib/flow/FlowReport'
import type { Answer } from '../../../shared/domain/flows/types.no-deps'
import type { ReportClientId } from '../../../shared/domain/reports/types.no-deps'
import { Subscriber } from '../../../shared/lib/Subscriber.no-deps'
import type { CachedUnitData } from '../../../shared/domain/units/CachedUnitData.no-deps'

export const Flow_updateSubscriber = new Subscriber<FlowReportUpdate>()

export function Flow_dispatchOpenStateChange(reportId: ReportClientId, openState: FlowReportStatus) {
    Flow_updateSubscriber.dispatch({ type: 'OpenStateChangeUpdate', reportId, openState }, sentry.simpleError)
}

export function Flow_dispatchNewAnswers(reportId: ReportClientId, newAnswers: Answer[]) {
    Flow_updateSubscriber.dispatch({ type: 'NewAnswersUpdate', reportId, newAnswers }, sentry.simpleError)
}

export function Flow_dispatchReportSynced(reportId: ReportClientId, parentClientId?: ReportClientId) {
    Flow_updateSubscriber.dispatch({ type: 'ReportSynced', reportId, parentClientId }, sentry.simpleError)
}

export function Flow_dispatchUnitDataChange(reportId: ReportClientId, cachedUnitData: CachedUnitData) {
    Flow_updateSubscriber.dispatch({ type: 'UnitDataChange', reportId, cachedUnitData }, sentry.simpleError)
}
